<script setup lang="ts">
  import { watch } from "vue";
  import { storeToRefs } from "pinia";
  import { RouterLink } from "vue-router";
  import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
  import ScriptingGuidelineList from "./ScriptingGuidelineList.vue";
  import { useScriptingGuidelinesStore } from "@stores/scriptingGuidelines";

  const props = defineProps<{ account: { id: number; name: string } | null }>();
  const open = defineModel<boolean>("open", { default: false });

  const store = useScriptingGuidelinesStore();
  const { accountRules } = storeToRefs(store);

  watch(open, (opened) => {
    if (opened && props.account) store.fetch(props.account.id);
  });
</script>

<template>
  <Sheet v-model:open="open">
    <SheetContent
      side="right"
      class="flex w-[40vw] flex-col overflow-hidden p-0 sm:max-w-[40vw]">
      <SheetHeader class="shrink-0 px-6 pt-4 pr-14 pb-4">
        <SheetTitle class="heading-title">{{ account?.name }} · Scripting guidelines</SheetTitle>
        <SheetDescription class="text-sm text-foreground/70">
          These rules add to the
          <RouterLink
            to="/admin/scripting-guidelines"
            class="underline underline-offset-2 hover:text-primary"
            >general rules</RouterLink
          >. When the two contradict each other, the account rule wins.
        </SheetDescription>
      </SheetHeader>

      <div class="flex-1 overflow-y-auto px-6 pb-6">
        <ScriptingGuidelineList
          :guidelines="accountRules"
          :account-id="account?.id ?? null"
          title="Rules of this account"
          empty-message="No rule specific to this account." />
      </div>
    </SheetContent>
  </Sheet>
</template>
